<template>
  <div>
    <ph-tabs :list="tabs" @tabClick="loadList" scrollable />
    <div
      v-for="(item, index) in list"
      :key="index"
      @click="showDetail(item)"
      class="list-item"
    >
      <img :src="item.titleimage" alt="" style="width: 4rem;" />
      <div>{{ item.title }}</div>
      <van-icon name="arrow" style="margin-right: 0;margin-left: auto;" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: [],
      list: [],
      content: ""
    };
  },
  created() {
    this.$http.post(this.$api.REFERENCE_HEALTHY_LIST_TYPE).then(res => {
      this.tabs = res.map(item => {
        return {
          ...item,
          name: item.articletypename
        };
      });
      this.loadList(res[0]);
    });
  },
  methods: {
    showDetail(item) {
      this.$router.push({
        name: "healthy-detail",
        query: {
          id: item.id
        }
      });
    },
    loadList(tab) {
      this.$http
        .post(this.$api.REFERENCE_HEALTHY_LIST, {
          articletype: tab.articletype
        })
        .then(res => {
          this.list = res;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.list-item {
  display: flex;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #f4f4f4;
  > div {
    margin-left: 1rem;
  }
}
</style>

<style lang="less">
.van-dialog__message {
  overflow-x: hidden;
}
</style>
